// ---------------------------------------------------------------------------
// AREAS OF PRACTICE — owner-supplied services & concerns. Language rule: never
// claim cures or guaranteed outcomes; always "care for people experiencing…"
// ---------------------------------------------------------------------------
export const PRACTICE_GROUPS = [
    {
        id: "spine",
        title: "Spine, Joint & Mobility Concerns",
        short:
            "The heart of our practice: hands-on, personalized care for people experiencing musculoskeletal discomfort and mobility-related concerns.",
        items: [
            {
                name: "Neck & Back Pain",
                text: "Personalized hands-on care for people experiencing neck and back discomfort — from long working hours to everyday strain — combining traditional marma knowledge with gentle therapeutic bodywork.",
            },
            {
                name: "Sciatica Pain",
                text: "Supportive care for people experiencing sciatica-related discomfort, using gentle techniques focused on comfort and ease of movement.",
            },
            {
                name: "Shoulder Pain",
                text: "Individualized care for people experiencing shoulder stiffness and discomfort, including concerns such as frozen shoulder, always adapted to your comfort.",
            },
            {
                name: "Joint Pain",
                text: "Traditional hands-on care for people experiencing joint discomfort, approached gently, patiently and personally.",
            },
            {
                name: "Knee Pain",
                text: "Supportive bodywork for people experiencing knee discomfort, focused on comfort and ease in everyday movement.",
            },
        ],
    },
    {
        id: "other",
        title: "Other Concerns",
        short:
            "Concerns commonly brought to the practitioner, approached as supportive wellness care — always alongside, never instead of, appropriate medical care.",
        items: [
            {
                name: "Sinus-Related Concerns",
                text: "People experiencing sinus-related discomfort sometimes seek traditional wellness care for relaxation and comfort. This is supportive care only — not a treatment for sinus conditions.",
            },
            {
                name: "Breathing-Related Concerns",
                text: "Calm, relaxation-focused sessions for guests who wish to unwind. Breathing difficulties can be serious: sudden, persistent or worsening symptoms require prompt medical evaluation.",
            },
            {
                name: "Headaches",
                text: "People experiencing occasional headaches and head tension often find relaxation-focused head and marma work restful. Frequent, severe or unusual headaches should be medically evaluated.",
            },
            {
                name: "Gastric & Digestive Discomfort",
                text: "Traditional wellness care centred on rest, relaxation and routine for people experiencing digestive discomfort. Persistent or severe symptoms deserve a doctor's assessment.",
            },
            {
                name: "Urinary Concerns",
                text: "Suspected or diagnosed urinary infections require appropriate medical evaluation and treatment. Traditional wellness care should not replace medical treatment — please consult a doctor first.",
            },
        ],
    },
    {
        id: "bodywork",
        title: "Traditional Wellness & Bodywork",
        short:
            "Ancient Marma Chikitsa and traditional bodywork therapies, offered as personalized wellness care in a calm, unhurried setting.",
        items: [
            {
                name: "Ancient Marma Chikitsa",
                text: "Our signature practice — gentle, precise touch on the body's traditional vital points, drawn from classical Ayurvedic knowledge and personalized to you.",
            },
            {
                name: "Foot Massage",
                text: "Traditional foot work, including unhurried attention to the soles, sought for deep rest and a grounded, settled feeling.",
            },
            {
                name: "Body Massage",
                text: "Full-body traditional massage, often with warm herbal oils in the Abhyanga tradition, for relaxation and everyday ease.",
            },
            {
                name: "Head Massage",
                text: "Calming traditional head massage — one of the simplest, most loved ways to quiet a busy mind.",
            },
            {
                name: "Cupping",
                text: "Traditional cupping bodywork, offered as a wellness practice and always adapted to your comfort.",
            },
            {
                name: "Scraping",
                text: "Traditional scraping techniques, offered as supportive wellness bodywork within a personalized session.",
            },
        ],
    },
];
